export const CPS_NOTIFICATION_TYPE = {
  NONE: 'none',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
} as const;

export type CpsNotificationType = (typeof CPS_NOTIFICATION_TYPE)[keyof typeof CPS_NOTIFICATION_TYPE];
